export default [
  {
    _id: { $oid: "62514d141dfe421e48609f29" },
    category: "Софтуер",
    description:
      "Проектът анализира снимки и позволява търсенето из тях по различни филтри(цветове, обекти в снимката, текст и още). Той е предназначен за хора, които искат лесно и бързо да намират и достъпват конкретни свои снимки. Най-голямата ми трудност беше разбирането на начина на функциониране на мобилните приложения. \n\nМартин Вайер: 'Гордея се с това, че проектът ми реално е полезен и планирам да го използвам.'",
    github: "https://github.com/VayerMaking/0r9an1zz3r",
    id: "62514d141dfe421e48609f29",
    mentor: "инж. Марио Бенов",
    name: "0r9an1zz3r",
    participants: ["Мартин Вайер - 12Б"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/0MW9GRTNF3s",
    pictures: ["1", "2", "3"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f2a" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът сканира обекти и ги експортва като Пойнт клоуд. Предназначен е за лично използване. \n\nИван Иванов:'Най-голямата ми трудност беше, че изгорих 1 arduino и няколко драйвера за стъпкови мотори, но се гордея, че проектът работи.'",
    github: "https://github.com/vankata05/3d_scanner",
    id: "62514d141dfe421e48609f2a",
    name: "3D Scanner",
    participants: ["Иван Иванов - 10А"],
    type: "Проект по ВМКС",
    youtube: "https://youtube.com/embed/OTTwTVUeUt8",
    pictures: ["4", "5", "6", "7", "8"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f2b" },
    category: "Софтуер",
    description:
      "AbilitY е уеб приложение, позволяващо на хората с увреждания и затруднения да получат помощ от други хора, решили да им помогнат със задачи, вариращи от най-обикновени нужди до пълни грижи за тях в случай, че техните роднини и познати нямат тази възможност. Това се случва чрез създаване на обяви, на които помощниците могат да отговарят и да приемат. Като стимулация за помощниците, всяка обява има предварително зададено от създателя възнаграждение под формата на парична сума. В приложението има вградена карта, която позволява по-лесно визуализиране на локациите на обявите с цел улесняване на работата на помощниците. \n\nAbilitY: 'Да направим този проект ни мотивира фактът, че има много хора по света, които не могат да живеят нормален живот, поради наследствени или придобити (в следствие на някаква травма/заболяване) увреждания. Нашата идея е да помогнем на тези хора и на роднините им, за които е невъзможно да се грижат за тях целодневно (поради работа). Най-големите ни трудности бяха обвързването на backend-а с frontend-а, както и сливането на различни branch-ове в GitHub. Гордеем се с това, че с нашата умела екипна работа, успяхме да направим напълно функциониращ сайт(с почти всичко, характерно за един такъв) в рамките на 2 дни.'",
    github: "https://github.com/generot/Memelitrix_HackTues8",
    id: "62514d141dfe421e48609f2b",
    name: "AbilitY",
    participants: [
      "Мартин Наков - 10Б",
      "Алекс Огнянов - 10Б",
      "Венелин Новаков - 10Б",
      "Димитър Николов - 10Б",
      "Емил Дойчинов - 10Б",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/0ilpCUhimSY",
    pictures: ["8"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f2c" },
    category: "Софтуер",
    description:
      "Affinity е един малко по-различен персонален асистент. Тя може да разпознава лицето на своя притежател, да играе на карти, разпознава жестове, възпроизвежда музика, уведомява за актуални новини и други, с усмивка на лице ;) . Да го разработим ни мотивира това, че сме от един клас и отдавна искаме да издигнем нещо заедно от нулата. Affinity е нашият пръв общ проект и ние сме изключително горди от прогресът, който имаме, и от хубавото време, което си прекарахме. \n\nAffinity: 'Най-големите пречки, които се изправиха пред нас, бяха непознатите за нас технологии. Балансът между натовареният ни училищен график и проекта също не помогна. Гордеем се с факта, че макар няколко пъти да бяхме близо до отказване, ние продължихме напред и заедно издигнахме проекта от нулата.'",
    github: "https://github.com/IvaAMarinova/Affinity",
    id: "62514d141dfe421e48609f2c",
    name: "Affinity",
    participants: ["Ива Маринова - 9В", "Томислав Русев - 9В"],
    type: "Проект от извънкласна дейност",
    youtube: "https://youtube.com/embed/gHTbR6KdlQ4",
    pictures: ["10", "11", "12"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f31" },
    category: "Софтуер",
    description:
      "Чрез лицево разпознаване, да се запазва информация за клиента какво си купува, и ако е редовен да има например намаления и др.",
    github: "https://github.com/1van4o/TUESFEST",
    id: "62514d141dfe421e48609f31",
    name: "AIZ",
    participants: ["Борис Стоянов - 8Г", "Стоян Бабанов - 8Г", "Иван Ламбев - 8Г"],
    type: "Проект от извънкласна дейност",
    youtube: "https://youtube.com/embed/53Xfknb2DZU",
    pictures: ["18", "19", "20", "21"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f2d" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът е устройство, което събира данни за времето и околната среда чрез сензори като например сензор за влажност, температура, надморска височина и атмосферно налягане, след което обработва информацията, показва я на LCD екран и я записва както на SD карта, така и на сървър. На сайт, който ще бъде достъпен за всички, се визуализира събраната информация под формата на графики. Направен е с цел улесняване и намаляване на цените на метеорологичните станции и публичен достъп до общите данни на даден район. ",
    github: "https://github.com/AlexOgn/All-in-one-weather.git",
    id: "62514d141dfe421e48609f2d",
    mentor: "Енчо Шаханов",
    name: "All-in-one-weather",
    participants: ["Алекс Огнянов - 10Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/mk9u9Nf9GFQ",
    pictures: ["13", "14"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f2f" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "AMRAAM е лека и евтина ракета с прецизно насочване, дори и срещу движещи се цели. \n\nСтанислав Иванов: 'Трудностите бяха много - при този проект няма нещо което да не ме лимитира. Тежест, размер, бюджет, скорост на софтуера, издръжливост на частите, захранване, аеродинамика и дори температурата от ракетния мотор, който може да стопи частите. Най-големият проблем от всичките бе тежестта. Трябваше да меря всеки грам и да търся най-леките материали за да може проекта да се използва с дрон. Гордея се с това, че го направих толкова бързо след като съм започнал от нулата, както и с неговата надеждност.'",
    github: "https://github.com/mynemjef/AMRAAM",
    id: "62514d141dfe421e48609f2f",
    name: "AMRAAM Самонасочваща се Ракета",
    participants: ["Станислав Иванов - 10Г"],
    type: "Проект от извънкласна дейност",
    youtube: "https://youtube.com/embed/9yWuW138nTY",
    pictures: ["15", "16"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f30" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът е устройство, което известява, че врата, която не бива да бъде отваряна е отворена. Проектът е курсова работа по предмета 'вградени микрокомпютърни системи'. Той може да се използва като бюджетна, но надеждна алармена система. По време на разработката се сблъсках с много трудности като използването на дгитален бутон като дигитален суич. ",
    github: "https://github.com/i-kratko/arduino-alarm-system",
    id: "62514d141dfe421e48609f30",
    mentor: "Енчо Шахънов",
    name: "Arduino Base Alarm System",
    participants: ["Николай Йорданов - 10Г"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/y7ISarHCyqs",
    pictures: ["17"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f32" },
    category: "Софтуер",
    description:
      "Проектът е уеб приложение, което визуализира различни алгоритми за намиране на път. Целта е да помага на хората да разберат как работят тези алгоритми. \n\nAstro Visualizer:'Най-голямата ни трудност беше имплементирането на алгоритмите в уеб приложението, а най-много се гордеем с това и красивия потребителски интерфейс.'",
    github: "https://github.com/bobikenobi12/kompetentnite",
    id: "62514d141dfe421e48609f32",
    mentor: "Иво Стратев",
    name: "Astro Visualizer",
    participants: [
      "Борислав Борисов - 8Г",
      "Габриел Петров - 8Г",
      "Никола Алексов - 8Г",
      "Ясен Цветков - 8Б",
      "Велизар Цикловски - 8Г",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/BwI53U_DRRQ",
    pictures: ["22", "23", "24", "25"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f33" },
    category: "Софтуер",
    description:
      "Проектът е игра на космическа тематика. Идеята за проекта се заражда на тазгодишния хакатон - Hack TUES Infinity. Неговата цел е да забавлява и разпуска потребителите.",
    github: "https://github.com/Misho12345/Astroland",
    id: "62514d141dfe421e48609f33",
    name: "Astroland",
    participants: ["Антон Христов - 8Б", "Стоян Иванов - 8Б", "Михаил Георгиев - 8Б"],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/dOxbOkRPipg",
    pictures: ["26", "27", "28", "29"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f34" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Целта на проекта е да реализира функционалност подобна на принтер. При подаден текстов файл, той се задава за принтиране и пишещата машина изпечатва този текст на хартия.",
    github: "https://github.com/YanaBaljieva/TUES_Fest",
    id: "62514d141dfe421e48609f34",
    mentor: "Г-н Росен Витанов",
    name: "At DM For Real",
    participants: ["Яна Балджиева - 11В"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/jOLSdW0RUB0",
    pictures: ["31", "32"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f35" },
    category: "Софтуер",
    description: ".",
    id: "62514d141dfe421e48609f35",
    mentor: "Иван Паунов",
    name: "CoDevil",
    participants: [
      "Антон Станков - 8Г",
      "Антон Станков - 8Г",
      "Тодор Стоименов - 8Г",
      "Иван Ламбев - 8Г",
      "Стоян Бабанов - 8Г",
      "Борис Стоянов - 8Г",
    ],
    type: "Проект от извънкласна дейност",
    pictures: ["33", "34", "35", "36", "37"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f36" },
    category: "Софтуер",
    description:
      "Проектът ще ви посрещне под формата на приложения, в които има високоинтелигентен мултифункционален, трениран от нас, изкуствен интелект от друга галактика. Както и красиво предоставена информация за нашата слъчева система.",
    github: "https://github.com/dot-ht/dot-project",
    id: "62514d141dfe421e48609f36",
    mentor: "Ангел Пенчев",
    name: "dot in space",
    participants: [
      "Калоян Дойчинов - 10А",
      "Алеко Георгиев - 10А",
      "Александър Иванов - 10А",
      "Кристиян Богданов - 10А",
      "Мартин Божилов - 10А",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/8S0m0JGqsLo",
    pictures: ["38", "39", "40", "41", "42"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f37" },
    category: "Софтуер",
    description:
      "Проектът е multiplayer игра. В нея всеки играч притежава империя, която е достигнала фаза в развитието си, в която трябва да експлоатира енергията от други планети, за да се развива. Има възможност за сблъсък между множество империите за контрол над галактиката. Целта на проекта е забавлява и развлича потребителите.",
    github: "https://github.com/TopchetoEU/energio",
    id: "62514d141dfe421e48609f37",
    name: "energ.io",
    participants: [
      "Калоян Венков - 9А",
      "Стилиян Мандалиев - 9А",
      "Мартин Раднев - 9А",
      "Любомир Милев - 9А",
      "Росен Маринов - 9А",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/FKVpc_LiJ5E",
    pictures: ["43", "43", "45", "46"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f38" },
    category: "Софтуер",
    description:
      "Проектът представлява флуиден симулатор, придружен с приложение, посредством което могат да се регулират основни конфигурации на флуида и неговата околна среда. Често погрешно схващане е, че флуид - това е течност. Флуидът всъщност е общо наименование на течности, газове и най-различни други консистенции като мед или дори някои видове пластмаси, които в по-дълъг времеви период се 'разтапят' или деформират по определен начин.",
    github: "github.com/vkabadzhova/equilibrium",
    id: "62514d141dfe421e48609f38",
    mentor: "Александър Ангелов",
    name: "Equilibrium",
    participants: ["Виолета Кабаджова - 12А"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/4cOxH_XCzl4",
    pictures: ["47", "48"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f3a" },
    category: "Софтуер",
    description:
      "Проектът представлява система от база данни - механизъм за съхранение, извличане и обработка на голямо количество данни. Може да бъде използвана и като библиотека за изграждане на по-строго специфични СУБД.",
    github: "https://github.com/boki1/eugene",
    id: "62514d141dfe421e48609f3a",
    mentor: "Любомир Стоянов",
    name: "Eugene",
    participants: ["Кристиян Стоименов - 12А", "Стоян Тинчев - 12А"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/Fbpnw7TtxT0",
    pictures: ["49"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f3b" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "GreenBo е самоходна радиоуправляема машина с роботизирана ръка, две камери, датчици и софтуер. \n\nGreenBo: 'Мотивация за този проект е желанието да сътворим нещо, което да може да има свой собствен живот и завършен вид, и да научим нови технологии.'",
    github: "https://github.com/AvatarBg111/GreenBo",
    id: "62514d141dfe421e48609f3b",
    name: "GreenBo",
    participants: ["Васил Колев - 10А", "Иван Иванов - 10А", "Яна Балджиева - 11В"],
    type: "Hack TUES",
    pictures: [],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f3c" },
    category: "Софтуер",
    description:
      "Проектът представлява игра. Проектът е предназначен за деца на възраст между 11 и 14 г. Целта на проекта е да привлечем нови ученици за ТУЕС.",
    github: "https://github.com/NickZach2036/HADIS",
    id: "62514d141dfe421e48609f3c",
    name: "HADIS",
    participants: ["Николай Захариев - 9А", "Димитър Грозев - 9А"],
    type: "Проект от извънкласна дейност",
    youtube: "https://youtube.com/embed/_hyDooSjBxk",
    pictures: ["50", "51"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f3d" },
    category: "Софтуер",
    description:
      "Проектът представя уебсайт, в който се предоставя подробна информация за билки, които могат да бъдат в помощ при определено заболяване.",
    github: "https://github.com/simeonikratko/herbaristika",
    id: "62514d141dfe421e48609f3d",
    name: "Herbaristika",
    participants: ["Симеон Йорданов - 10А"],
    type: "Проект от извънкласна дейност",
    pictures: [],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f3e" },
    category: "Софтуер",
    description:
      "Калкулатор, който разчита чрез камера броя пръсти и пресмята. \n\nЕлена Чернева: 'Вдъхновение за проекта е брат ми, който ще бъде в първи клас и се учи да смята на пръсти.'",
    github: "https://github.com/xcWhy/TuesFEST.git",
    id: "62514d141dfe421e48609f3e",
    name: "irlCalc",
    participants: ["Елена Чернева - 9Г"],
    type: "Проект от извънкласна дейност",
    youtube: "https://youtube.com/embed/gEp7lRPsb80",
    pictures: ["52", "53", "54"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f3f" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Свети и изписва часа върху лед матрицата, пуска музика от spotify на телефона. Проекта е предназначен за всички, които имат проблем с ранното ставане, афинитет към лед лампи и музика.",
    github: "https://github.com/JIOjosBG/itsglowtime",
    id: "62514d141dfe421e48609f3f",
    mentor: "Росен Витанов",
    name: "It`s Glow Time",
    participants: ["Йосиф Хамед - 11Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/AaXG44ug2rA",
    pictures: ["55", "56", "57"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f40" },
    category: "Софтуер",
    description:
      "JoinMe е социална мрежа за менажиране на събития и създаване на запознанства. Неговата цел е да социализира и развлича потребителите му, като разрешава и един от ежедневните проблеми в днешно време - недостига на приятел за дадено забавление/събитие. \n\n",
    github: "https://github.com/Alexander1022/JoinMe",
    id: "62514d141dfe421e48609f40",
    mentor: "Атанас Манолов",
    name: "JoinMe",
    participants: ["Александър Йорданов - 12Б"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/1KmAmJIDNoM",
    pictures: ["58", "59", "60", "61", "62"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f77" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът прави палачинки на газов котлон, като ги обръща автоматично.                              Ирина Ахамад: 'Това е първият ми завършен embedded проект и се гордея с това, че се справих с проектирането и сглобяването. С този проект искам да създам интересен на вид механизъм и да развия сръчността, инженерното мислене, знанията и уменията ми в сферата на вградените микрокомпютърни системи.'",
    github: "https://github.com/irina-mandarina/Crepe-machine.git",
    id: "62514d141dfe421e48609f77",
    mentor: "Росен Витанов",
    name: "Krepinator",
    participants: ["Ирина Ахамад - 11Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/g4wLFRsRBhE",
    pictures: ["203", "204", "205"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f41" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът следи човешки лица в реално време, превръща получените данни в Х и У координати, чрез които два серво мотора движат лазерен диод. Главната функционалност на системата е проследяване на човешки лица и показването на 'мерник'.",
    github: "https://github.com/AHumbeBarcode/L.E.A.N.Turret",
    id: "62514d141dfe421e48609f41",
    name: "L.E.A.N. Turret (Laser Enabled Automatically Navigating Turret)",
    participants: ["Александър Бояджиев - 10Г", "Теодор Василевс - 10Г"],
    type: "Проект от извънкласна дейност",
    youtube: "https://youtube.com/embed/-KReZmQNq58",
    pictures: ["63", "64", "65", "66", "67"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f42" },
    category: "Софтуер",
    description:
      "Проектът представлява образователна 2D игра, направена на Python чрез библиотеката Pygame. В играта главната цел на играча е да преминава през различни нива, като за целта трябва да изпълнява мисии на даденото ниво преди да може да премине към следващото. При успешното изпълнение на дадена мисия играчът получава интересен факт, свързан с Космоса.",
    github: "https://github.com/AvatarZorak/HackTUES",
    id: "62514d141dfe421e48609f42",
    name: "Learn to Space",
    participants: [
      "Александър Христов - 9А",
      "Петър Петров - 9А",
      "Росен Маринов - 9А",
      "Димитър Желев - 9Г",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/GK2G2o9h6SQ",
    pictures: ["68", "69", "70", "71", "72"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f43" },
    category: "Роботика и вградени микрокомпютърни системи",
    description: "Показва час, температура и влажност. Проектът е с образователна цел.",
    github: "https://github.com/Hrist0ff/tuesfest-project-2022",
    id: "62514d141dfe421e48609f43",
    mentor: "Преподавател - Росен Витанов",
    name: "LED Часовник със сензор за температура и влажност, направен с Arduino",
    participants: ["Александър Христов - 11Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/t4RBGP7CFco",
    pictures: ["73"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f44" },
    category: "Софтуер",
    description:
      "Улеснява подбирането на място за кацане на отдалечени космически обекти. Проектът е насочен към хора изпълняващи мисии до отдалечени космически обекти. ",
    github: "https://github.com/VayerMaking/lemniskata",
    id: "62514d141dfe421e48609f44",
    name: "Lemniskata",
    participants: [
      "Мартин Вайер - 12Б",
      "Виолета Кабаджова - 12А",
      "Стоян Тинчев - 12А",
      "Кристиян Стоименов - 12А",
      "Захари Момчилов - 12Г",
    ],
    type: "Hack TUES",
    pictures: [],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f45" },
    category: "Софтуер",
    description:
      "Проектът е 2D platformer игра. \n\nLife Beyond:'Най-голямо предизвикателство беше изработването на enemies, bosses и art design.'",
    github: "https://github.com/NickProgrammerGaming/LifeBeyond",
    id: "62514d141dfe421e48609f45",
    name: "Life Beyond",
    participants: ["Никола Кръстанов - 9Г", "Александър Мечкаров - 9Г", "Даниел Икономов - 9Г"],
    type: "Hack TUES",
    website: "https://nickgamingbruh.itch.io/life-beyond",
    pictures: ["74", "75", "76", "77", "78"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f46" },
    category: "Роботика и вградени микрокомпютърни системи",
    description: "Следва черна линия. Проектът е насочен предимно за по-младата аудитория.",
    github: "https://github.com/bigIq/LineFollower-VMKS-",
    id: "62514d141dfe421e48609f46",
    mentor: "Енчо Шахънов",
    name: "LineFollower",
    participants: ["Викторио Миланов - 10Г"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/NHr7-YqFhHc",
    pictures: ["79", "80"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f47" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Главната функционалност е движение напред, назад, наляво и надясно. \n\nВенелин Новаков: 'Най-големите трудности бяха грешните преценки на задвижване на моторчетата, с който се извършва движението на колата с дистанционно управление.'",
    github: "https://github.com/Venko15/LWC",
    id: "62514d141dfe421e48609f47",
    mentor: "Енчо Шахънов",
    name: "LWC",
    participants: ["Венелин Новаков - 10Б"],
    type: "проект по предмета ВМКС",
    youtube: "https://youtube.com/embed/KLzVK0iZLGA",
    pictures: ["81", "82", "83"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f48" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Робот с 6 колела, който лайвстриймва и има ръка, която може да се контролира. Проекта представя 24/7 стрийм от друга планета.",
    github: "https://GitHub.com/filio123321/TuesFest2022",
    id: "62514d141dfe421e48609f48",
    name: "MarsIT",
    participants: [
      "Филостратос Титопулос - 9Г",
      "Александра Лазарова - 9В",
      "Огнян Разсадов - 9В",
      "Евгени Попов - 9Г",
    ],
    type: "Hack TUES",
    pictures: ["84"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f49" },
    category: "Софтуер",
    description:
      "Главната му функционалност е да показва къде има бункери в София. Целта на проекта е да осигурява надежден сайт, който да информира хората къде да се скрият при военна атака.",
    github: "https://github.com/Flychuban/TUES_FEST2022_FLASH",
    id: "62514d141dfe421e48609f49",
    name: "MEB",
    participants: [
      "Калоян Анастасов - 8А",
      "Таня Колева - 8А",
      "Виктор Златев - 8А",
      "Константин Златев - 8А",
      "Калоян Анастасов - 8А",
    ],
    type: "Специално за феста проект.",
    website: "https://flychuban.github.io/TUES_FEST2022_FLASH/index.html",
    youtube: "https://youtube.com/embed/AeY8IQGRWVo",
    pictures: ["85", "86", "87", "88"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f4a" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява модифициран воден бластер. Може да намери приложение в ежедневни нужди на хората като напояване на почви, гасене на малки пожари, но най-вече за забавни водни битки с приятели.",
    github: "https://github.com/BojoPopnikolov/Water_Cannon.git",
    id: "62514d141dfe421e48609f4a",
    mentor: "Росен Витанов",
    name: "Mega Soaker",
    participants: ["Божидар Попниколов - 11В"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/wcFVxdsSyf8",
    pictures: ["89"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f4b" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява възможност ръчно да бъдат сменяни параметри в програми за създаване на музика.",
    github: "https://github.com/DanailYordanov/MIDIController",
    id: "62514d141dfe421e48609f4b",
    mentor: "Росен Витанов",
    name: "MIDI Controller",
    participants: ["Данаил Йорданов - 11Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/OrcHbxF5pz4",
    pictures: ["90", "91", "92"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f4c" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява машината за смесване на напитки. Неговата цел е да се направи\nосвежаващ микс, с възможност за охлаждане.",
    github: "https://github.com/didoP247/MixIT",
    id: "62514d141dfe421e48609f4c",
    mentor: "Росен Витанов",
    name: "MixIT",
    participants: ["Дамян Пенков - 11Г", "Георги Кочияшки - 11Г"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/dLWsrOsSuTc",
    pictures: [],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f4d" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява футболна маса с добавени са функционалности като: автоматично отброяване на разултат и засичане на продължителността на играта, симулиране на атмосферата на реален стадион, чрез звукови ефекти и връщане на топчето от вратата до място за пускането му обратно в игра.",
    github: "https://github.com/Liverpoolfan92/TableFootball.git",
    id: "62514d141dfe421e48609f4d",
    name: "Modern Table football",
    participants: ["Борислав Желев - 11Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/gigxhSPWITU",
    pictures: ["93", "94", "95"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f4e" },
    category: "Компютърни мрежи",
    description:
      "Проектът е дипломна работа в 12 клас. Предназначен е за service providers. Осигурява layer 3 VPN услуга на клиентите между 2 AS        Traffic engineering.",
    id: "62514d141dfe421e48609f4e",
    mentor: "Христо Войнски",
    name: "MPLS Option C",
    participants: ["Александър Христов - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/_jECJbWyPno",
    pictures: ["96"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f4f" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Целта на проекта е да улеснява потребителите в четенето на книги. Негови функционалности са: да свети когато е тъмно; да брои страници; да изчислясава средна скорост на четене. Проектът е насочен към хора, които обичат да четат хартиени книги.",
    github: "https://github.com/Stanislav04/My-Reading-Assistant",
    id: "62514d141dfe421e48609f4f",
    name: "My Reading Assistant",
    participants: ["Александра Станчева - 11А", "Станислав Иванов - 11А"],
    type: "Проект от извънкласна дейност",
    pictures: [],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f50" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът стреля патрони чрез Bluetooth. \n\nNerf Turret: 'Свързването на отделните елементи бе най - трудното в процеса на създаване на проекта.'",
    github: "https://github.com/AlexGechovski/NerfTurret",
    id: "62514d141dfe421e48609f50",
    name: "Nerf Turret",
    participants: ["Алекс Гечовски - 11А", "Явор Пачеджиев - 11А"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/dBVUO683Z1M",
    pictures: ["97", "98", "99", "100"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f51" },
    category: "Софтуер",
    description:
      "Проектът разширява пазара на NFT. Подходящ е за всеки, който се интересува от криптовалути и NFT.",
    github: "https://github.com/bobikenobi12/nftopus",
    id: "62514d141dfe421e48609f51",
    name: "NFTopus",
    participants: [
      "Габриел Мартинов - 8Г",
      "Борислав Борисов - 8Г",
      "Никола Алексов - 8Г",
      "Кристиан Кирилов - 8Г",
      "Габриел Петров - 8Г",
    ],
    type: "Проект от извънкласна дейност",
    youtube: "https://youtube.com/embed/hAqZVqCK9wk",
    pictures: ["101", "102", "103"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f52" },
    category: "Софтуер",
    description:
      "Notewell улеснява процеса на самоподготовка чрез предоставяне на средства и среда за създаване и споделяне на план-конспекти и тестове към тях, като така се предоставя достъп до кратка и ключова информация и се улеснява усвояването на преподадения материал в училище или университета.",
    github: "https://github.com/false-positive/notewell",
    id: "62514d141dfe421e48609f52",
    mentor:
      "Ръководител на проекта: ст. преподавател Мила Нейкова; Ментори на проекта: Теодора Йовчева, Илиян Кордев",
    name: "Notewell",
    participants: ["Божидар Павлов - 9В", "Денис Мирчев - 9В", "Калоян Миладинов - 9В"],
    type: "Проект от Ученически Иновационен Хъб",
    youtube: "https://youtube.com/embed/9xlNYvvwpQA",
    pictures: ["104", "105", "106", "107", "108"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f53" },
    category: "Софтуер",
    description:
      "Проектът представлява сайт с малки аркадни игрички. Проектът е предназначен за всеки, на когото му е скучно и му се играе нещо простичко.\n\nЕкипът:  'Желанието да участваме в Туес Фест ни мотивира да разработим проекта.'",
    github: "https://github.com/atanas-rujinov/tuesFest",
    id: "62514d141dfe421e48609f53",
    name: "PixGame",
    participants: [
      "Атанас Ружинов - 8В",
      "Светослав Иванов - 8В",
      "Кристиян Андреев - 8В",
      "Лора Иванова - 8В",
    ],
    type: "Проект специално за ТУЕС Фест",
    youtube: "https://youtube.com/embed/5A_wjbPtSDM",
    pictures: ["109"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f54" },
    category: "Софтуер",
    description:
      "Проектът представлява мобилна игра/симулатор, използваща реалната информация от Космоса. Идеята е да предоставим на обикновения човек не само достоверна и актуална информация за заобикалящия ни Космос, но и начин да взаимодейства с обектите в него. Това се случва посредством изстрелване на ракети, събиране на различни ресурси и изследване на всякакви космически тела. Действието на играта се развива в нашата Слънчева система.",
    github: "https://github.com/YassenEfremov/Planet-Prospect",
    id: "62514d141dfe421e48609f54",
    mentor: "Милен Спасов",
    name: "Planet Prospect",
    participants: [
      "Ясен Ефремов - 11А",
      "Ивайло Генчев - 11А",
      "Явор Пачеджиев - 11А",
      "Симеон Христов - 11А",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/cP45a3-uM9o",
    pictures: ["110", "111", "112"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f55" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Целта на проекта е да се грижи за растения. \n\nЕмилиана: 'Бях мотивирана да разработвам проекта от това, че обичам растенията, но нямам достатъчно време да се грижа за тях ежедневно.'",
    github: "https://github.com/EmilianaAP/Plant_365.git",
    id: "62514d141dfe421e48609f55",
    mentor: "Енчо Шаханов",
    name: "Plant 365",
    participants: ["Емилиана Петренко - 10Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/DPsEDcYYClo",
    pictures: ["113", "114"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f56" },
    category: "Софтуер",
    description:
      "Quizzi е мобилно приложение за любознателни хора, които се интересуват от Космоса. Въпросникът съдържа въпроси за различни космически обекти, експедиции, астронавти. Всяка игра включва въпроси със затворен отговор, таймер за отговор, подсказки, изображение. Всеки ден потребителите получават интересен факт, а към всеки има въпрос има и възможност за повече информация за най-любопитните.",
    github: "https://github.com/0DakatA0/Destroy-Uranus",
    id: "62514d141dfe421e48609f56",
    mentor: "Николай Марков",
    name: "Quizzi",
    participants: [
      "Християн Тодоров - 11В",
      "Данаил Стоилов - 11В",
      "Андрей Иванов - 11В",
      "Християна Ангелова - 9Г",
      "Чавдара Белева - 9Г",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/R19ZfIfUvSI",
    pictures: ["115", "116", "117", "118", "119"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f57" },
    category: "Софтуер",
    description:
      "Проектът е приложение, което те подсеща за всички задължения които му зададеш. Има опцията bot да да изпраща напомняния по имейла и по различни социални мрежи на потребителя.",
    github: "https://github.com/alt-plus-f4/RemindaNi",
    id: "62514d141dfe421e48609f57",
    name: "RemindaNi",
    participants: [
      "Анна-Мариа Димитрова - 9Б",
      "Емил Момчев - 9Б",
      "Томислав Иванов - 9Б",
      "Валентин Асенов - 9Б",
    ],
    type: "Проект от извънкласна дейност",
    website: "https://remindani.coderr.tech/",
    youtube: "https://youtube.com/embed/TJ2lb0SRDnw",
    pictures: ["120", "121", "122"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f59" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът е вдъхновен от темата за Космоса от Hack TUES и е насочен към космонавите. В случай на авария в МКС космонавтите да могат бързо да се ориентират в околната среда.",
    github: "https://github.com/Russian-SPUTNIK/Main_Repo",
    id: "62514d141dfe421e48609f59",
    mentor: "Красимир Иванов",
    name: "Safe Cosmos Costume",
    participants: [
      "Виктор Димитров - 10Г",
      "Ивайло Каньов - 10Б",
      "Емилия Чукалева - 10Г",
      "Мартин Тарлев - 10Г",
      "Пламена Георгиева - 10Г",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/VbDnsPckeV0",
    pictures: ["123", "124", "125"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f5a" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът показва температурата и качеството на въздуха в стаята, както и броя на хората в стаята. Целта е да се подсигури безопасна работна среда с чист въздух, на подходяща температура. ",
    github: "https://github.com/Lachezar-Velinov/Safety_Screen",
    id: "62514d141dfe421e48609f5a",
    mentor: "Росен Витанов",
    name: "Safety Screen",
    participants: ["Лъчезар Велинов - 11А", "Ясен Ефремов - 11А"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/masAKAg9IuU",
    pictures: ["126", "127", "128", "129", "130"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f5b" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "ScruTINY е преносима система за защита, може да бъде поставена навсякъде, по всяко време. Работи само на 9 волта захранване. Тя е приспособена за безжична комуникация със собственика си. Това се постига чрез връзка, посредством Wi-Fi мрежа. Системата трябва първоначално да бъде конфигурирана с компютър/лаптоп, за да може да осъществява връзка с дадена (по време на конфигурацията) Wi-Fi мрежа. ScruTINY има два начина за осъществяване на предназначението си: Засичане на движение и засичане на (силен) звук. При смущаване на сензорите на системата (засечено движение в стаята или твърде силен звук/шум), тя изпраща информация за смута на онлайн сървър, от който собственикът може да види пратената информация, независимо къде се намира на света (стига да има връзка с Интернет). Освен това, се активира и звуковата аларма на системата, която се състои от един зумер (buzzer - високоговорител, който издава звук на подадена честота), с цел да разобличи случващото се на хора в периметъра.",
    github: "https://github.com/generot/ScruTINY",
    id: "62514d141dfe421e48609f5b",
    mentor: "Енчо Шахънов",
    name: "ScruTINY",
    participants: ["Мартин Наков - 10Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/-CQ_m5r5dQE",
    pictures: ["131", "132", "133"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f5c" },
    category: "Софтуер",
    description:
      "sEDUbg е платформа за споделяне на учебни материали. \n\nЕкипът: 'Мотивира ни липсата на леснодостъпен учебен материал от всякакво (от общообразователни до професионални предмети) съдържание в интернет.'",
    github: "https://github.com/sEDUbg/sEDUbg",
    id: "62514d141dfe421e48609f5c",
    name: "sEDUbg",
    participants: ["Калоян Дойчинов - 10А", "Мартин Божилов - 10А"],
    type: "Проект от извънкласна дейност",
    website: "http://sedubg.com",
    youtube: "https://youtube.com/embed/mwL1noMFx-E",
    pictures: ["134"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f5d" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Машина за млечни шейкове, предоставяща разнообразни вкусове, които придават свежо настроение на хората, които ги консумират. Машината предоставя възможност всеки да прави комбинациите от вкусове, които харесва. Това се случва чрез бутони, всеки отговарящ за различна съставка. След смесването им се добавя мляко и се блендират продуктите. Получената смес е готова за консумация от крайния потребител.\nЗа да осъществяване на машината ще бъдат използвани микроконтролер Arduino, който ще контролира целия процес на създаване на желания краен продукт шейк. За смесването на съставките ще използва блендер, свързан с реле. Изпомпването на млякото ще става чрез перисталтична помпа. Течността ще минава посредством маркуч. Машината ще разполага с LCD екран с бутони. Изборът на клиента ще се случва съответно чрез тези бутони, с които ще минава през различните плодове.",
    github: "https://github.com/MariVidkov/Shakey",
    id: "62514d141dfe421e48609f5d",
    mentor: "Росен Витанов",
    name: "Shakey",
    participants: ["Мариян Видков - 11Г", "Цветина Джунакова - 11Г"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/rKDVIgCJxeE",
    pictures: ["160", "161", "162", "163", "164"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f5e" },
    category: "Софтуер",
    description:
      "Проектът представлява имплементация на база с данни в паметта на компютъра. Главната му функционалност е да запазва данни и да позволява тяхното връщане.",
    github: "https://github.com/DimoYo/Shegi4kiG4",
    id: "62514d141dfe421e48609f5e",
    name: "Shegi4kiG4",
    participants: ["Димо Йорданов - 11Б"],
    type: "Курсова работа",
    pictures: [],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f5f" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Идеята на проектът е чрез Arduino да контролира осветлението на стаята. Това може да се случва по множество различни начини:\n-Чрез сензор за звук (Sound Sensor)\n-Чрез сензор за движение (PIR Sensor)\n-Чрез Интернет (ESP8266)",
    github: "https://github.com/IvanGeorgievProgramming/SIMP",
    id: "62514d141dfe421e48609f5f",
    name: "SIMP Лампа",
    participants: ["Иван Георгиев - 10А"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/_ckixF-LkWk",
    pictures: ["135"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f60" },
    category: "Софтуер",
    description:
      "Проектът представлява приложение, което позволява на потребителя да научи нови неща за Космоса и след това да провери знанията си чрез интерактивна тестова система.",
    github: "https://github.com/dr-programmer/HackTues8---TE-AM-new",
    id: "62514d141dfe421e48609f60",
    mentor: "Теодора Йовчева",
    name: "SIRIUS",
    participants: ["Дарий Топузов - 8В", "Антонио Готев - 8В", "Дамян Мяшков - 8В"],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/_Q8QbSpDH2k",
    pictures: ["136", "137", "138", "139", "140"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f7d" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "SISC е устройство с умен Discord BOT.\nИма следните команди:\n * !help - Shows this message. \n * !pic - Takes an instant picture. \n * !start - Starts SISC. \n * !stop - Stops SISC.\n!pic ще изпрати моментна снимка на потребителя.\n!start стартира засичането на движения - при всяко движение ще се изпраща анализирана снимка на потребителя.\n!stop спира засичането на движения.",
    github: "https://github.com/YordanMarkov/SISC/tree/master/TUES%20Fest%202022",
    id: "62514d141dfe421e48609f7d",
    name: "SISC",
    participants: ["Йордан Марков - 11В", "Мина Слаова - 11В"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/-6xsypqUZlA",
    pictures: ["222", "223", "224", "225"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f61" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът ни представлява алармена система, която съчетава функциите на 'Умен дом' и 'Умна ключалка'. Целта му е да улеснява ежедневието и предпазването от крадци, като използва различни компоненти.",
    github: "https://github.com/dimitar-tsvetkov/TUES-fest",
    id: "62514d141dfe421e48609f61",
    name: "Smart Alarm",
    participants: ["Димитър Цветков - 10Г", "Моника Спасова - 10Г"],
    type: "Проект по специален предмет",
    youtube: "https://youtube.com/embed/LjTRRh1SC04",
    pictures: ["141", "142", "143"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f62" },
    category: "Роботика и вградени микрокомпютърни системи",
    description: "Целта му е да се върти.",
    id: "62514d141dfe421e48609f62",
    mentor: "Росен Витанов",
    name: "Smart Basketball Hoop",
    participants: ["Златина Лилова - 11А", "Мартин Златанов - 11А"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/W_FkV8SDHSc",
    pictures: ["144"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f63" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Главната цел на проекта е да можеш да контролираш лампите в дома си само с телефон.",
    id: "62514d141dfe421e48609f63",
    mentor: "Росен Витанов",
    name: "Smart Home Controller",
    participants: ["Данаил Божков - 11А", "Иваело Кръстев - 11А"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/rw1vTZrP-J4",
    pictures: ["145", "146"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f64" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява кола, която се управлява чрез мобилно приложение. Най-трудна беше работата с поялник.",
    github: "https://github.com/DBozhkovV/TuesFestProject",
    id: "62514d141dfe421e48609f64",
    mentor: "Росен Витанов",
    name: "Smart RC car",
    participants: ["Симеон Христов - 11А", "Кристиан Косев - 11А"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/IyHZv_UZnsg",
    pictures: ["147", "148", "149", "150"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f65" },
    category: "Софтуер",
    description:
      "Проектът е 2D ски игра. Играчът може да избере между два режима - слалом и офроуд, както и между три различни трудности. Целта е да постигне възможно най-добър резултат.",
    github: "https://github.com/Boyko03/snow",
    id: "62514d141dfe421e48609f65",
    name: "Snow",
    participants: ["Бойко Георгиев - 12В"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/KxQItVnPRuQ",
    pictures: ["151", "152", "153", "154", "155"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f66" },
    category: "Софтуер",
    description:
      "Проектът е игра, в която играчът създава и развива своя космическа станция и се грижи за нейния екипаж.",
    github: "https://github.com/RayaLitova/SpaceInnovators",
    id: "62514d141dfe421e48609f66",
    mentor: "Марио Бенов - ментор",
    name: "Space Innovators",
    participants: [
      "Матей Вълов - 11Б",
      "Рая Литова - 11Б",
      "Андрей Тодоров - 11Б",
      "Ирина Ахамад - 11Б",
      "Александър Асса - 11Б",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/BUFG-gYDSf0",
    pictures: ["156", "157", "158", "159"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f67" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява преносимо устройство с множество сензори, което изпраща събраните от тях данни по Bluetooth до уеб сървър, където те биват запазени в база данни за определено време. Когато потребител достъпи сайта, му бива предоставена информацията от базата данни под формата на таблица, както и няколко на брой графики, за да бъде по-лесно проследяването на промените в стойностите. Сензорите са главно за отчитане на концентрации на различни газове, като има и сензор за температура. При достигане на стойности извън нормата се задейства звукова аларма. Предвидено е да се постави в помещение на космическа станция, където да измерва качеството на въздуха.",
    github: "https://github.com/lubo04/jub",
    id: "62514d141dfe421e48609f67",
    mentor: "Симеон Георгиев",
    name: "Space Jub",
    participants: [
      "Любомир Начев - 11Г",
      "Адриан Стоев - 11Г",
      "Ясен Спасов - 11Г",
      "Иво Иванов - 11Г",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/WoasIbXS8cE",
    pictures: ["165", "166", "167"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f68" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът включва засичане на обекти и даване на сигнал, ако даден обект е на 40 см от ръката на космонавта, както и проследяване на позицията и ориентацията посредством жироскопичен сензор, който се ползва като input за buzzer-и, които служат за обратна връзка дали човекът е в нормална ориентация или не.",
    github: "https://github.com/i-kratko/SpaceVision",
    id: "62514d141dfe421e48609f68",
    mentor: "Пламен Данов, IBM България",
    name: "SpaceVision",
    participants: [
      "Иван Иванов - 10Г",
      "Викторио Миланов - 10Г",
      "Веселин Владимиров - 10Г",
      "Николай Йорданов - 10Г",
      "Любомир Станев - 10Г",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/IIPBrzVwf1o",
    pictures: ["168", "169", "170"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f69" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проекът е умна касичка. Неговата цел е да отброява пусната монета или поставена банкнота. След като отчете какъв е номинала на пуснатата стотинка или банкнота се пускат към съответниге кошове, в които се съхраняват всички паднали монети и банкноти. Стотинката се пуска по наклонена рампа, а банкнотата се поставя на хоризонтална плоскост, закрепена върху мотор, който след като отчете каква банкнота е се завърта надолу и пуска банкнотата в съответния кош.",
    github: "https://github.com/Hristiyyann/Smart-Piggy-Bank",
    id: "62514d141dfe421e48609f69",
    mentor: "Росен Витанов",
    name: "SPB",
    participants: ["Християн Радев - 11Б"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/OhTkBNZUm9o",
    pictures: ["171", "172", "173", "174", "175"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f7b" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява система, която следи за природните условия извън космическа станция. В зависимост дали са благопритни се получава индекс, който показва дали е безопасно да да се излиза, и ако има твърде резки промени във времето се известяват космонавтите",
    github: "https://github.com/JIOjosBG/hacktues8",
    id: "62514d141dfe421e48609f7b",
    mentor: "Велизар Стоянов",
    name: "SPIM",
    participants: [
      "Николай Лазаров - 11А",
      "Йосиф Хамед - 11Б",
      "Християн Радев - 11Б",
      "Йоан Джелекарски - 12Г",
    ],
    type: "Hack TUES",
    youtube: "https://youtube.com/embed/RdunZ2kk6As",
    pictures: ["213", "214", "215", "216"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f6a" },
    category: "Софтуер",
    description: "Проектът представлява игра. Неговата цел е да забавлява потребителите.",
    github: "https://github.com/i-kratko/pygame-tues-fest",
    id: "62514d141dfe421e48609f6a",
    name: "StunRun",
    participants: [
      "Иван Иванов - 10Г",
      "Викторио Миланов - 10Г",
      "Веселин Владимиров - 10Г",
      "Николай Йорданов - 10Г",
      "Любомир Станев - 10Г",
    ],
    type: "Проект от извънкласна дейност",
    youtube: "https://youtube.com/embed/7qpkv6T070I",
    pictures: ["176", "177", "178", "179"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f6b" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява кола с дистанционно управление за забавление. Най-голяма гордост е антената, която има голям обхват.",
    github: "https://github.com/username0143/T-31",
    id: "62514d141dfe421e48609f6b",
    name: "T-31",
    participants: ["Мартин Дойчинов - 8Б", "Александър Шестаков - 8Б", "Ясен Цветков - 8Б"],
    type: "собствен проект",
    youtube: "https://youtube.com/embed/MIrDFmdlh5g",
    pictures: ["180", "181", "182", "183"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f6c" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът постоянно събира информация за препятствията около човека, и го информира ако има такива.",
    github: "https://github.com/the-kaska/The_KASKA/blob/main/README.md",
    id: "62514d141dfe421e48609f6c",
    name: "The КАSКА",
    participants: ["Иван Петков - 8Г", "Александър Асенов - 8Г"],
    type: "Проект от извънкласна дейност",
    pictures: ["184", "185", "186"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f6d" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява IoT система, чиято цел е да позиционира текущото местоположение на даденото превозно средство, където е поставено устройството. Чрез мобилно приложение, потребителят може да добавя неопределен брой устройства, както и да ги проследява през интегрираната Google карта.",
    github:
      "https://github.com/Lilly7777/VPTS-Backend, https://github.com/Lilly7777/VPTS-Client, https://github.com/Lilly7777/VPTS-App",
    id: "62514d141dfe421e48609f6d",
    mentor: "Росен Недялков",
    name: "Trackify",
    participants: ["Лилия Любенова - 12Б"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/UYvKMC5V8ew",
    pictures: ["187"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f6e" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът е насочен за космонавти. Превежда различни езици в реално време. Улеснява комуникацията между космонавти говорещи различни езици. ",
    github: "https://github.com/y0608/TtT",
    id: "62514d141dfe421e48609f6e",
    mentor: "Евгени",
    name: "TtT Pager",
    participants: [
      "Йоан Иванов - 10В",
      "Георги Фиданов - 10Б",
      "Радослав Филипов - 10В",
      "Живко Нушев - 10В",
      "Димитър Димитров - 10В",
    ],
    type: "Hack TUES",
    pictures: [],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f6f" },
    category: "Компютърни мрежи",
    description:
      "Проектът е предназначен за всяка фирма, която има желание да наблюдава състоянието на сървърите си по оптимален начин. Проектът представлява мониторинг система, която се състои от няколко сървъра, между които се извършва балансиране на натоварването. Тя има отчетен модул, който праща дневни отчети и е интегриран с Discord чрез бот, който позволява да се генерират персонализирани отчети.        \n\nЙоан Джелекарски: 'Най-голямата трудност при разработването на дипломния ми проект беше, че използвам над десет различни технологии, които трябваше да накарам да работят заедно. Срокът за това беше три месеца, но успоредно с всички предмети, които изучаваме в училище, времето не е никак много.        Най-много се гордея с факта, че проектът ми до известна степен съчетава и софтуер, и комютърни мрежи. Така той представя уменията ми в различни области на системната администрация.'",
    github: "https://github.com/dzhelek/diploma-project-2022/tree/tuesfest",
    id: "62514d141dfe421e48609f6f",
    mentor: "Павлин Николов",
    name: "Zabbix мониторинг система с load balancing",
    participants: ["Йоан Джелекарски - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/kyH_HsXEKbg",
    pictures: ["188", "189", "190", "191", "192"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f70" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Целта на проекта е да раздава карти за три вида покер и белот. Допълнителни функции са да следи и показва резултата на играта на белот, да следи колко играча остават в играта на покер. Може би да показва кой играч е наред да плати задължителните малка (small blind) и голяма такса (big blind) в началото на всяко раздаване на покер.",
    github: "https://github.com/Migumagunata/TUESFest2022",
    id: "62514d141dfe421e48609f70",
    mentor: "Росен Витанов",
    name: "Автомагична картораздавачка",
    participants: ["Михаил Бошкилов - 11Г"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/0_YSXPL_5So",
    pictures: ["193"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f71" },
    category: "Роботика и вградени микрокомпютърни системи",
    description: "Проектът показва цена, зададена му през блутут и телефон",
    github: "https://github.com/AdmiralaYT/pricetag",
    id: "62514d141dfe421e48609f71",
    name: "Дигитален Pricetag",
    participants: ["Михаел Динков - 11Г", "Стефан Касамаков - 11Г"],
    type: "Курсова работа",
    pictures: [],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f72" },
    category: "Компютърни мрежи",
    description:
      "Проектът е дипломна работа в 12 клас. Насочен е към  компании, които си изграждат корпоративната мрежа. Работата му е да се създаде мрежа, в която има резервираност и свързаност между различните офиси, да свързва отдалечени офиси с помощта на протокола BGP, да се конфигурира защитната стена.",
    github: "https://drive.google.com/drive/folders/10K8VHQR-4tVyKErJ0e0PqqaMcPa-Mg1_",
    id: "62514d141dfe421e48609f72",
    mentor: "Илия Илиев",
    name: "Изграждане на корпоративна мрежа на различни географски локации, свързани чрез BGP",
    participants: ["Мирослав Минков - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/fAZtymDTUfQ",
    pictures: ["194", "195"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f73" },
    category: "Компютърни мрежи",
    description:
      "Проекът представя едни от най-често срещаните технологии за изграждане на корпоративни мрежи, като позволи да се изгради собствен модел за свързаност за една компания от нулата.         Проектът е насочен всички модерни компании, независимо дали малки или големи, като улеснява изграждането на мрежовата свързаност между офисите на корпорацията.        Проектът симулира мрежовата свързаност чрез трета фаза на технологията DMVPN между три отдалечени и един централен офис на една компания. Използвани са множество протоколи, като mGRE, NHRP, EIGRP, IPsec, HSRP, чрез които са постигнати най-високи нива на резервираност, сигурност и работоспособност на мрежовата топология.         \n\n\nКалоян Пашов: :Гордея се с това, че проектът работи по предназначение и предлага готово за използване решение за изграждане на корпоративна свързаност.'",
    github: "https://github.com/Kaloyan-Pashov/DMVPN.git",
    id: "62514d141dfe421e48609f73",
    mentor: "ст. инж. Мартин Начков",
    name: "Изграждане на корпоративна мрежа чрез трета фаза на DMVPN свързаност.",
    participants: ["Калоян Пашов - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/qG3YwznlvdQ",
    pictures: ["196"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f74" },
    category: "Компютърни мрежи",
    description:
      "Проектът е предназначен за хора с опит в областта на компютърните мрежи. Същността на проекта е постигане на VPN свързаност между два клиентски офиса.\nГлавните функционалности са Layer 2 и Layer 3 VPN свързаността, както и успешната работа на всички протоколи и технологии.        \n\nГергана Узунова: ' Най-голямата трудност, която срещнах беше първоначалното разбиране на съвместната работа на използваните протоколи и технологии. Най-много се гордея с пълната функционалност на проекта.'",
    id: "62514d141dfe421e48609f74",
    mentor: "Петър Димитров",
    name: "Изграждане на мрежа, свързваща два офиса на една компания, използваща VPN услуга",
    participants: ["Гергана Узунова - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/6BM28Mfopsc",
    pictures: ["197"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f75" },
    category: "Компютърни мрежи",
    description:
      "'Темата на проекта е сравнително нова технология, която тепърва навлиза в пазара ни. Някои компании прехвърлят инфраструктурата си към EVPN, но има голяма част от сектора, която все още преценява дали си заслужава. С тази дипломна работа се разбира малко повече за технологията и възможностите, които тя предоставя. Проектът е предназначен за доставчици на услуги - компании, които предоставят мрежови решения и/или услуги на крайни потребители и организации. Дипломната работа представя примерна инфраструктура върху хардуер на установен от индустрията производител. Проекта има за цел да представи EPVN технологията, която позволява свързване на разпръснати клиентски точки с помощта на “виртуален комутатор” на слой 2. За постановката е избран сценарий, който свързва два центъра за данни. Поради нуждите на такъв тип клиенти е добавена и функционалостта L3VPN, който позволява на клиентските мрежи да достъпват Интернет през опорната мрежа.  Най-големите трудности при разработването на проекта бяха свързани с конфигурацията на EVPN услугата. Поради новостта на технологията хардуерът не се държеше така както трябва, но това е рискът от използване на реално оборудване.\n\nЗахари Момчилов: 'Най-много се гордея с придобитите умения за troubleshooting покрай новите технологии. С разрешаването на всеки възникнал проблем се добавя и нещо ново, за което да се проверява при последвали пречки от същия тип.'",
    id: "62514d141dfe421e48609f75",
    mentor: "маг. инж. Радостина Герчева",
    name: "Изграждане на свързаност между центрове за данни чрез MPLS-базиран EVPN",
    participants: ["Захари Момчилов - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/2HJdfgDisDo",
    pictures: ["198", "199", "200", "201"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f76" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представлява конзолна игра за елиминиране на паразити. В него са вложени много от знанията, придобити през тази учебна година.",
    id: "62514d141dfe421e48609f76",
    mentor: "Росен Витанов",
    name: "Конзола за игра",
    participants: ["Николай Лазаров - 11А"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/NeEtv8sJb5k",
    pictures: ["202"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f78" },
    category: "Компютърни мрежи",
    description:
      "Проектът е дипломна работа в 12 клас. Насочен в сферата на облачните решения. Позволява на инженерите да се фокусират върху разработването на нови функционалности за приложението, както и върху оптимизацията на процеса. Подобни решения се разработват и надграждат с години с последното поколение технологии, тъй като конкуренцията на пазара нараства всеки ден, а компаниите трябва да се адаптират все по-бързо, за да отговарят на нуждите на потребителите.         \n\nНастоящата дипломна работа цели да разгледа в дълбочина модела 'Инфраструктура като код', добрите практики за управлението на една надеждна инфраструктура, да изследва контейнеризиращата технология, оркестрацията и да се постигне автоматизирана непрекъсната доставка на контейнеризирано приложение в облачна среда посредством GitOps практиките. По време на реализацията на проекта се следват практиките от GitOps модела:\n\n- Първият принцип е, че всички необходими ресурси за изграждането на облачното решение трябва да се съхраняват в Git хранилище. Избраната платформа за система на контрол на версиите е GitLab. Всички инструменти, с които се постига непрекъснатата доставка, извличат от хранилището кода за изграждането на инфраструктурата, ресурсите за приложението и манифестите за доставянето му. Благодарение на това се позволява оптимизацията на управлението на инфраструктурата и предоставянето на нови функционалности до крайните потребители. \n\n- Вторият принцип гласи, че одобрените промени трябва да се имплементират автоматично. За тази цел се реализира CI/CD pipeline, който се изпълнява спрямо това дали е направена промяна по приложението, или по инфраструктурата. Създава се нов Docker имидж чрез Dockerfile. Имиджът се съхранява в регистъра на GitLab, откъдето си и променя тага спрямо номера на направения комит, а с помощта на Kustomize се променя тага на имиджа в Kubernetes Deployment обекта. Състоянието на инфраструктурата се дефинира чрез Terraform, с което се постига модела ''Инфраструктура като код''. Google Cloud актуализира използваните ресурси за проекта спрямо декларираното желано състояние в GitLab.\n\n- Kubernetes обектите се актуализират с помощта на Flux, който през 5 минути сравнява текущото състояние на обектите в клъстера с това, което е дефинирано в хранилището, с което се постига и третият принцип – мониторинг на системата, който да алармира при разминаване между текущото състояние и желаното.\n\n- Четвъртият принцип твърди, че системата трябва да бъде дефинирана чрез декларативен подход, а това се постига с Terraform и Kubernetes. \n\nВиктория Димитрова: 'Трудности изникваха постоянно! Най-вече, защото в началото си нямах и идея от използваните технологии, даже и от техните принципи и практики, но с много четене, пробване, разбира се, и с помощта на моя дипломен ръководител, за което съм му изключително благодарна, успях да завърша проекта.        Гордея се, че вече осъзнавам критично важната за бизнеса тематика, че преминах през процес по планиране и реализиране на подобно решение, и най-вече с това, че РАБОТИ!'",
    github: "https://gitlab.com/cyanopus/continuous-delivery-with-gitops-in-kubernetes/-/tree/main",
    id: "62514d141dfe421e48609f78",
    mentor: "Валентин Петров",
    name: "От кухнята на големите компании",
    participants: ["Виктория Димитрова - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/xKnTxBZMgTU",
    pictures: ["209"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f79" },
    category: "Компютърни мрежи",
    description:
      "Проектът е дипломна работа в 12 клас. Проектът е предназначен за компании, състоящи се от повече отдалечени офиси. Целта на дипломната работа е да се изгради компютърна мрежа, която не е комплексна и трудна за изграждане и поддържане и едновременно с това да е надеждна и защитена. \nКорпоративната мрежа се състои от три офиса в различни градове.\nЦентралният офис се намира в град София и се състои от три маршрутизатора. Два от изпълняват ролята на Hub за DMVPN, като са конфигурирани в Active/Stand by режим. Единият маршрутизатор работи в активен режим, докато другия ще премине в активен режим само ако възникне грешка или проблем с първия. Третият маршрутизатор служи за връзка между другите два.\nОфисите в Пловдив и Бургас са идентични. Всеки един от тях се състои от един маршрутизатор, един комутатор и компютри. Маршрутизаторите изпълняват ролята на Spokes за DMVPN. И поради това, че DMVPN е Фаза 3, маршрутизаторите в двата офиса могат да изграждат VPN тунели помежду си без данните да минават през маршрутизатора, изпълняващ ролята на Hub. Маршрутизаторите в двата офиса служат и за DHCP сървъри. В локалните мрежи на двата офиса е имплементиран протоколът STP. Освен това има три VLANs: за ИТ отдела, за отдела Човешки ресурси и за отдела Продажби. Като всеки от отделите може да изпраща информация само на устройства от своята виртуална частна мрежа.\nМаршрутизацията между трите офиса се извършва чрез протоколът EIGRP.\n\nНия Маркова: 'Най-голямата ми трудност бе работата със симулатора, който използвах. Сигурно, докато го използвах, се натъкнах на всички възможни видове грешки. По време на разработването на проекта се сблъсквах и с други по-малки трудности, породени от това, че част от технологиите, които използвах, бяха непознати за мен. Но накрая всички препятствия бяха преодолени и успях да завърша проекта. Най-много се горедея с това, че успешно завърших проекта си, той покрива всички изисквания и работи, както трябва. '",
    id: "62514d141dfe421e48609f79",
    mentor: "Илия Илиев",
    name: "Проектиране и изграждане на корпоративна мрежа между 3 локации с DMVPN Phase 3 и мрежовия протокол EIGRP",
    participants: ["Ния Маркова - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/q3Z3zaZV7dA",
    pictures: ["206", "207", "208"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f7a" },
    category: "Компютърни мрежи",
    description:
      "Проектът е дипломна работа в 12 клас в сферата на кибер сигурността. Насочен е към организации, които искат да защитят данните си.        Системата, с помощта на платформата Netwrix Auditor, събира логове от различни среди и ги анализира. Софтуерът генерира отчети, дава възможност за настройване на аларми и помага на една органзация да поддържа съответсвие с основни стандарти за одит на информационната сигурност.        \n\nСлавянка Йовчева: 'Най-много се гордея, че излязох от комфортната си зона и създадох функциониращ проект от нулата.'",
    id: "62514d141dfe421e48609f7a",
    mentor: "Дипломен ръководител - Мартин Раков",
    name: "Система за одит на промените, базирана на анализ на логовете и Netwrix Auditor",
    participants: ["Славянка Йовчева - 12Г"],
    type: "Дипломна работа",
    youtube: "https://youtube.com/embed/Al2UbdZpdRc",
    pictures: ["210", "211", "212"],
  },
  {
    _id: { $oid: "62514d141dfe421e48609f7c" },
    category: "Роботика и вградени микрокомпютърни системи",
    description:
      "Проектът представя звук в цветна светлина. Любовта ми към изкуството ме вдъхнови да създам този проект.",
    github: "https://github.com/AI18527/ColorMusic_Project#readme",
    id: "62514d141dfe421e48609f7c",
    mentor: "Росен Витанов",
    name: "Цветомузика",
    participants: ["Авигея Илиева - 11А"],
    type: "Курсова работа",
    youtube: "https://youtube.com/embed/YZkPXQ0kxew",
    pictures: ["217", "218", "219", "220", "221"],
  },
];
